"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiSelectState = void 0;
const selectors_1 = require("../selectors");
const useSelector_1 = require("./useSelector");
const EMPTY_STATE = {
    isActive: false,
    isExplodeActive: false,
    isRedoActive: false,
    isUndoActive: false,
    items: [],
    selectedItemIndex: -1,
};
function useMultiSelectState() {
    return (0, useSelector_1.useSelector)(selectors_1.selectMultiSelectState) || EMPTY_STATE;
}
exports.useMultiSelectState = useMultiSelectState;
